import axios from 'axios'

export default async function deleteTest({ id }: { id: number }) {
  await axios.delete(`/api/v1/test/${id}`)
}
